import styled from "styled-components";

export const MainContainer = styled.main`
    height: 80vh;
    overflow-y: scroll;
`